'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiniBasket = undefined;

var _MiniBasket2 = require('./MiniBasket');

var _MiniBasket3 = _interopRequireDefault(_MiniBasket2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MiniBasket = _MiniBasket3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/MiniBasket/index.js
// module id = 1688
// module chunks = 0